const ITSupportFeature = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            Feature
          </p>
          <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              当社のサイト制作の特徴
          </h4>
        </div>

        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] overflow-hidden">
          <div className="p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#89B56B]/10 text-[#89B56B]">
                <i className="ri-shopping-cart-line text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">ECサイト</h3>
            </div>

            <div className="flex flex-col md:flex-row gap-8">
              <div className="md:w-[240px] flex-shrink-0">
                <div className="w-full h-[180px] rounded-xl overflow-hidden bg-[#F8FBF6]">
                  <img
                    src="/image/product1.jpeg"
                    alt="ECサイト制作例 - 3SQUARE"
                    title="ECサイト制作 - 株式会社MSK"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="flex-1">
                <p className="text-[13px] text-gray-700 leading-[2] mb-4">
                  私たちは、どうしたらお客様に心から信頼して頂けるECサイトを作成出来るか？を模索し、自らECサイトを運営する事によりお客様と同じ立場になろうと考えました。
                </p>
                <p className="text-[13px] text-gray-700 leading-[2] mb-4">
                  ECサイトの作成から運営までを行っているからこそ、他社とは違うノウハウを持っており、自信を持ってお勧め出来るのです。
                </p>
                <p className="text-[13px] text-gray-700 leading-[2] mb-6">
                  一般消費者向けのBtoCサイトだけではなく、法人向けのBtoBサイトも作成可能です。また、販売可能なものは実物に限らず、「音楽ファイル」「画像データ」などデジタルコンテンツにも対応しています。サイトのデザインにつきましてもお客様のご要望に沿って作成いたします。
                </p>
                <div className="text-center md:text-left">
                  <a
                    href="/ec-detail"
                    className="inline-flex items-center gap-2 bg-[#89B56B] text-white px-10 py-3.5 rounded-full font-medium hover:bg-[#5DAA68] transition-all duration-300 shadow-lg shadow-[#89B56B]/20 cursor-pointer whitespace-nowrap"
                  >
                    詳しく見る
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ITSupportFeature;
